import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { CheckIcon } from 'lucide-react';
const benefits = ['Enhance skin tone and texture', 'Minimize the appearance of enlarged pores', 'Preserve a youthful complexion', 'Delay the onset of premature aging', 'Boost collagen production for a rejuvenated appearance', 'Achieve softer, smoother, and more elastic skin', 'Enhance skin clarity, smoothness, and glow', 'Diminish fine lines and wrinkles', 'Enhance skin absorption for better skincare efficacy'];
export function CBBenefits() {
  return <section className="bg-black py-[60px] lg:py-[100px]" data-id="element-431">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8" data-id="element-432">
        <AnimateOnScroll className="text-center flex flex-col items-center mb-12" data-id="element-433">
          <h2 className="text-[26px] lg:text-[40px] uppercase text-white leading-tight mb-4 font-[600] font-[Poppins,_sans-serif]" data-id="element-434">
            BENEFITS OF CLEAR + BRILLIANT TOUCH
          </h2>

          <p className="font-serif italic text-[#B0B0B0] text-[17px] leading-[1.7] max-w-[800px] mb-6" data-id="element-435">
            Clear + Brilliant Touch embodies an innovative therapy system
            featuring dual handheld devices and distinct laser wavelengths, each
            gentle yet potent. This unique laser treatment can address a variety
            of aesthetic concerns:
          </p>

          <div className="w-[40px] h-[2px] bg-[#FF1493]" data-id="element-436"></div>
        </AnimateOnScroll>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5" data-id="element-437">
          {benefits.map((benefit, index) => <AnimateOnScroll key={index} delay={index * 60} data-id="element-438">
              <div className="bg-[#111111] p-6 flex items-start gap-4 h-full group hover:shadow-[0_0_20px_rgba(255,20,147,0.1)] transition-shadow duration-300" data-id="element-439">
                <CheckIcon size={20} className="text-[#FF1493] flex-shrink-0 mt-0.5" data-id="element-440" />
                <span className="text-white text-[15px] leading-[1.5] font-body" data-id="element-441">
                  {benefit}
                </span>
              </div>
            </AnimateOnScroll>)}
        </div>
      </div>
    </section>;
}